import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageConfigService } from '../language-config.service';
import { relatedSaldoNewsModel } from '../help/components/help-card/help-card-model';
import { SeoService } from '@app/core/services/seo.service';
import { OgService } from '@app/core/services/og.service';

@Component({
    selector: 'app-press',
    templateUrl: './press.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./press.component.scss']
})
export class PressComponent {
    public relatedSaldoNews: Array<any> = relatedSaldoNewsModel;
    public notRedirect: boolean = false;

    public receiveEvent($event: any): void {
        this.notRedirect = $event;
    }

    public constructor(
        private seoService: SeoService,
        private ogService: OgService,
        private activatedRoute: ActivatedRoute,
        private languageConfigService: LanguageConfigService,
        public router: Router
    ) {
        this.languageConfigService
            .setActivatedRoute(this.activatedRoute)
            .updateLanguageFromUrl('about-as')
            .subscribe(() => {
                this.seoService.addTitle('Quiénes Somos | Saldoar');
                this.ogService.addOpenGraphMetadata({ url: 'wiki/about-us', urlOgImage: 'assets/images/og/og-about.png' });
                this.seoService.addCanonical('wiki/about-us');
            });
    }
}
